import { cn } from "@rosette/ts/src/util/cn.js";


interface AnalysisBarPercentageProps {
    children: string;
    vertical: boolean;
    light: boolean;
}


function AnalysisBarPercentage({ children, vertical, light }: AnalysisBarPercentageProps) {
    let position: string;
    if (vertical) {
        position = cn("w-full text-center scale-90", light ? "bottom-[0.25em]" : "top-[0.25em]");
    } else {
        position = cn("top-1/2 -translate-y-1/2", light ? "left-[0.25em]" : "right-[0.25em]");
    }
    return (
        <p className={cn(
            "absolute m-0 px-0 py-1 font-bold text-[11px] md:text-[14px]",
            light ? "text-black" : "text-body",
            position,
        )}>
            {children}
        </p>
    );
}


interface AnalysisBarProps {
    className?: string;
    lwp?: number;
    orientation?: "horizontal" | "vertical";
}


export function AnalysisBar({ className, lwp, orientation = "vertical" }: AnalysisBarProps) {
    const vertical = (orientation === "vertical");
    return (
        <div className={cn(
            "relative bg-analysis-bar",
            vertical ? "h-full w-7.5 min-w-7.5 md:w-10 md:min-w-10" : "h-7.5 min-h-7.5 md:h-10 md:min-h-10",
            className ?? null,
        )}>
            {lwp !== undefined && (
                <>
                    <div
                        className={cn(
                            "absolute left-0 bottom-0 bg-accent-strong transition-[height,width] duration-300 ease-in-out",
                            vertical ? "w-full h-1/2" : "w-1/2 h-full",
                        )}
                        style={vertical ? { height: `${lwp}%` } : { width: `${lwp}%` }} />

                    <div className={cn(
                        "absolute bg-surface-sunken",
                        vertical
                            ? "top-1/2 left-[10%] w-4/5 h-0.5 -translate-y-1/2"
                            : "left-1/2 top-[10%] h-4/5 w-0.5 -translate-x-1/2",
                    )} />

                    {lwp > 5 && (
                        <AnalysisBarPercentage vertical={vertical} light={true}>
                            {`${lwp.toFixed(0)}%`}
                        </AnalysisBarPercentage>
                    )}

                    {lwp < 95 && (
                        <AnalysisBarPercentage vertical={vertical} light={false}>
                            {`${(100 - lwp).toFixed(0)}%`}
                        </AnalysisBarPercentage>
                    )}
                </>
            )}
        </div>
    );
}
